import { Container, Header } from "@cloudscape-design/components-themed";
import { IErrMsg, LABELS } from "./constants";
import { BankAccountReference } from "./BankAccountReference";
import { BankAccountUpdate } from "./BankAccountUpdate";
import {
  BankAccountForBankAccount,
  BankAccountsUpdateRequest,
} from "../../features/api-interfaces";
import { Dispatch, SetStateAction } from "react";

interface IBankAccount {
  bankAccount?: BankAccountForBankAccount;
  isModalOpen: boolean;
  isUpdate: boolean;
  request: BankAccountsUpdateRequest;
  setRequest: Dispatch<SetStateAction<BankAccountsUpdateRequest>>;
  errMsg: IErrMsg;
  setErrMsg: Dispatch<SetStateAction<IErrMsg>>;
}

/**
 * 入金口座情報照会・更新 口座情報
 */
export const BankAccount = (props: IBankAccount) => {
  const {
    bankAccount,
    isModalOpen,
    isUpdate,
    request,
    setRequest,
    errMsg,
    setErrMsg,
  } = props;

  return (
    <Container
      header={<Header variant={"h2"}>{LABELS.BANK_ACCOUNT_TITLE}</Header>}
    >
      {isUpdate ? (
        <BankAccountUpdate
          request={request}
          setRequest={setRequest}
          errMsg={errMsg}
          setErrMsg={setErrMsg}
        />
      ) : (
        <BankAccountReference
          bankAccount={bankAccount}
          isModalOpen={isModalOpen}
        />
      )}
    </Container>
  );
};
